'use client';

import React from 'react';
import { ExperienceType } from '../types';
import ExperienceVideos from '@/components/stay-experience/ExperienceVideos';

interface ExperienceVideoGalleryProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceVideoGallery: React.FC<ExperienceVideoGalleryProps> = ({
  experience,
  type,
}) => {
  if (!experience || type !== 'package') return null;

  const exp = experience as {
    videos?: Array<{
      videoUrl?: string;
      thumbnailUrl?: string;
      imageUrl?: string;
      title?: string;
      url?: string;
      name?: string;
    }>;
    reviewVideos?: Array<{
      videoUrl?: string;
      thumbnailUrl?: string;
      imageUrl?: string;
      title?: string;
      url?: string;
      name?: string;
    }>;
    media?: Array<{
      format?: string;
      url?: string;
      thumbnailUrl?: string;
      title?: string;
      name?: string;
    }>;
  };

  const getThumbnailUrl = (video: {
    thumbnailUrl?: string;
    imageUrl?: string | string[];
  }): string => {
    if (video.thumbnailUrl) return video.thumbnailUrl;
    if (Array.isArray(video.imageUrl) && video.imageUrl[0]) {
      return video.imageUrl[0];
    }
    if (typeof video.imageUrl === 'string' && video.imageUrl) {
      return video.imageUrl;
    }
    return '/assets/images/No-Image.jpg';
  };

  // Extract videos and convert to format expected by ExperienceVideos component
  // ExperienceVideos expects: { thumbnailUrl: string, videoUrl: string }
  const videos: Array<{ thumbnailUrl: string; videoUrl: string }> = [];

  // Check videos array
  if (Array.isArray(exp?.videos)) {
    exp.videos.forEach(video => {
      const videoUrl = video.videoUrl || video.url;
      if (videoUrl) {
        videos.push({
          thumbnailUrl: getThumbnailUrl(video),
          videoUrl,
        });
      }
    });
  }

  // Check reviewVideos array
  if (Array.isArray(exp?.reviewVideos)) {
    exp.reviewVideos.forEach(video => {
      const videoUrl = video.videoUrl || video.url;
      if (videoUrl) {
        videos.push({
          thumbnailUrl: getThumbnailUrl(video),
          videoUrl,
        });
      }
    });
  }

  // Check media array for video format
  if (Array.isArray(exp?.media)) {
    exp.media.forEach(item => {
      if (item.format === 'video' && item.url) {
        videos.push({
          thumbnailUrl: item.thumbnailUrl || '/assets/images/No-Image.jpg',
          videoUrl: item.url,
        });
      }
    });
  }

  if (videos.length === 0) return null;

  // Use ExperienceVideos component to match activities design
  return <ExperienceVideos videos={videos} />;
};
